import React from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdbreact'
import BasicLabel from "../SharedComponents/BasicLabel/BasicLabel";
import BasicTextField from '../../components/SharedComponents/BasicTextField/BasicTextField';
import SelectField from '../SharedComponents/SelectField/SelectField';
import BasicButton from '../SharedComponents/BasicButton/BasicButton';
import SearchSelectField from '../SharedComponents/SearchSelectField';
import CasterService from '../../../services/service';
import * as Constants from '../../../constants/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
import BasicTextArea from '../SharedComponents/BasicTextArea/BasicTextArea';
import './EditSendPaymentsTo.scss';
import AddressComponent from "../../Common/AddressComponent/AddressComponent";
import MessageModal from '../../components/SharedComponents/MessageModal';

class EditSendPaymentsTo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAddress: null,
            selectedEntity: null,
            isPosting: false,
            postInitiated: false,
            talentOptions: [],
            addressOptions: [],
            backUpTalentOptions: [],
            isFetchingData: false,
            notes: this.props?.sendToPaymentList?.[0]?.entity_notes ? this.props?.sendToPaymentList?.[0]?.entity_notes : null,
            openNewExternalUserSection:false,
            editExternalUserSection:false,
            is_delete_flag:false,
            is_deleting: false
        }

    }

    componentDidMount = () => {
        this.getEditSendPaymentToDetails()
    }


    getEditSendPaymentToDetails = () => {
        this.setState({ isFetchingData: true });
        CasterService.getData(Constants.CasterServiceBaseUrl + `/casterFeaturePerformerDealContactPaymentsTo?performer_deal_id=${this.props?.deal_id}&talent_id=${this.props?.talentId}`)
            .then(response => {
                let talentsArray = response?.data?.map(item => {
                    let newItem = { ...item }
                    // newItem.is_active = item?.address?.length > 0 ? 1 : 0
                    newItem.value = item?.code
                    newItem.text = item?.entity_type === 'T' ? `Talent (${item?.selected_alias_name ? item?.selected_alias_name : ''})` :
                        item?.entity_type === 'R' ? `Representative (${item?.selected_alias_name ? item?.selected_alias_name : ''})` :
                        item?.entity_type === 'E' ? `External Contact (${item?.selected_alias_name ? item?.selected_alias_name : ''})` :
                            `(Guardians ${item?.selected_alias_name ? item?.selected_alias_name : ''})`
                    newItem.address = item?.address?.map((ele => {
                        let newEle = { ...ele }
                        newEle.value = `${ele?.code ? ele?.code : ''}${ele?.primary_address_id ? ele?.primary_address_id : ''}`
                        newEle.label = ele?.entity_full_address || null
                        return newEle
                    }))
                    return newItem

                })

                let selectedEntity = talentsArray?.filter(i => i?.entity_id == this.props?.sendToPaymentList?.[0]?.entity_id && i?.entity_type == this.props?.sendToPaymentList?.[0]?.entity_type);

                let selectedAddress = selectedEntity?.[0]?.address?.filter(i => i?.entity_full_address == this.props?.sendToPaymentList?.[0]?.address)?.[0]?.value || null;
                this.setState({
                    talentOptions: talentsArray,
                    talentOptionsBackup: JSON.parse(JSON.stringify(talentsArray)),
                    backUpTalentOptions: response.data,
                    isFetchingData: false,
                    selectedEntity: selectedEntity?.[0] || null,
                    addressOptions: selectedEntity?.[0]?.address || []

                }, () => {
                    this.setState({ selectedAddress })
                });

            },
                (err) => {
                    console.log("Error in fetching Production Details:", err)
                })
    }

    handleSubmit = () => {
        this.setState({ postInitiated: true })
        let postObj = {}
        if (this.state.selectedExternalPayeeAddress || this.state.selectedEntity?.entity_type === "E") {
            let objToUse = this.state.selectedExternalPayeeAddress ? this.state.selectedExternalPayeeAddress : this.state.selectedEntity?.address[0];
            postObj.selected_alias_name = this.state.selectedExternalPayeeAddress ? this.state.newExternalTalent : this.state.selectedEntity?.selected_alias_name;
            postObj.project_id = this.props?.project_id || null
            postObj.performer_deal_id = this.props?.deal_id || null
            postObj.is_send_payment_to = 1,
            postObj.entity_id = this.props?.deal_id || null
            postObj.entity_type = "E"
            postObj.address_type = objToUse?.address_type || null,
            //postObj.entity_full_address = addressInfo?.entity_full_address || null
            postObj.entity_notes = this.state.notes || null
            postObj.entity_address = this.state.selectedExternalPayeeAddress ? objToUse?.address : objToUse?.entity_address || null,
            postObj.entity_state =  this.state.selectedExternalPayeeAddress ? objToUse?.state?.value ? objToUse?.state?.value : objToUse?.state : objToUse?.entity_state || null,
            postObj.entity_city =  this.state.selectedExternalPayeeAddress ? objToUse?.city : objToUse?.entity_city || null,
            postObj.entity_country = this.state.selectedExternalPayeeAddress ? objToUse?.country?.value ? objToUse?.country?.value : objToUse?.country : objToUse?.entity_country || null,
            postObj.entity_zip =  this.state.selectedExternalPayeeAddress ? objToUse?.zip : objToUse?.entity_zip || null,
            postObj.talent_id =  this.props?.talentId || null,
            this.postRepresentativeDetails(postObj)
        }else if (this.state.selectedAddress && this.state.selectedEntity?.value) {
            let addressInfo = this.state.addressOptions?.find(item => item?.value === this.state.selectedAddress)
            postObj.selected_alias_name = this.state.selectedEntity?.selected_alias_name
            postObj.project_id = this.props?.project_id || null
            postObj.performer_deal_id = this.props?.deal_id || null
            postObj.is_send_payment_to = 1,
            postObj.entity_id = this.state.selectedEntity?.entity_id || null
            postObj.entity_type = this.state.selectedEntity?.entity_type || null
            postObj.address_type = addressInfo?.address_type || null
            postObj.entity_full_address = addressInfo?.entity_full_address || null
            postObj.entity_notes = this.state.notes || null
            postObj.entity_address = addressInfo?.entity_address || null
            postObj.entity_state =  addressInfo?.entity_state || null
            postObj.entity_city =  addressInfo?.entity_city || null
            postObj.entity_country =  addressInfo?.entity_country || null
            postObj.entity_zip =  addressInfo?.entity_zip || null
            this.postRepresentativeDetails(postObj)
        }
    }

    postRepresentativeDetails = (sendPaymentsTo, origin=null) => {
        this.setState({ isPosting: true, postInitiated: false })
        CasterService.postDataParams(Constants.CasterServiceBaseUrl + '/casterFeaturePerformerDeal', sendPaymentsTo)
            .then((response) => {
                if (response.data.error) {
                    this.props?.notificationComponent(true, 'fail')
                } else {
                    if (this.props?.toggleRefreshPage) {
                        this.props.toggleRefreshPage()
                    }
                    if(origin === "fromDelete"){
                        this.props?.onClose()
                    }
                    this.props?.notificationComponent(true, 'success')
                }
                this.setState({ isPosting: false, is_deleting: false, is_delete_flag: false })
            }, (err) => {
                this.setState({ isPosting: false, is_deleting: false, is_delete_flag: false })
                this.props?.notificationComponent(true, 'fail')
            });
    }

    onChange = (value) => {
        let selectedEntity = this.state.talentOptions?.find(item => item?.value === value?.value)
        this.setState({
            selectedEntity: selectedEntity,
            backupselectedEntity: selectedEntity,
            selectedAddress: selectedEntity?.address?.length > 1 ? selectedEntity?.address?.find(item => item?.is_primary === 1)?.value || null : selectedEntity?.address[0]?.value || null,
            addressOptions: selectedEntity?.address,
            openNewExternalUserSection: false,
            editExternalUserSection: false
        })

    }
    addNewExternalContactPayment = () => {
        this.setState({openNewExternalUserSection: !this.state.openNewExternalUserSection,
            editExternalUserSection: false,
        })
    }
    updateAddress = (address,talentName) =>{
        let talentOptions = this.state.talentOptions;
        let tempNewEntity = {};
        tempNewEntity["address"]=[];
        tempNewEntity["project_crew_id"]=null;
        tempNewEntity["code"]="External Contact-"+talentName;
        tempNewEntity["entity_id"]=this.props?.deal_id || null
        tempNewEntity["selected_alias_name"]=this.state?.newExternalTalent;
        tempNewEntity["entity_type"]="E";
        tempNewEntity["relation"]=null;
        tempNewEntity["value"]="External Contact-"+talentName;
        tempNewEntity["text"]="External Contact ("+talentName+")";
        
        let tempNewEntityAddress={};
        tempNewEntityAddress["address_type"]=address?.address_type;
        tempNewEntityAddress["entity_address"]=address?.entity_address;
        tempNewEntityAddress["code"]="External Contact-"+talentName;
        tempNewEntityAddress["entity_city"]=address?.entity_city?address?.entity_city:"";
        tempNewEntityAddress["entity_country"]=address?.entity_country;
        tempNewEntityAddress["entity_zip"]=address?.entity_zip?address?.entity_zip:"";
        tempNewEntityAddress["entity_state"]=address?.entity_state?address?.entity_state:"";
        tempNewEntityAddress["entity_full_address"]=tempNewEntityAddress["entity_address"]+ " "+tempNewEntityAddress["entity_city"]+" "+tempNewEntityAddress["entity_state"]+" "+tempNewEntityAddress["entity_zip"]+" "+tempNewEntityAddress["entity_country"];
        tempNewEntityAddress["is_primary"]=null;
        tempNewEntityAddress["label"]=tempNewEntityAddress["entity_address"]+ " "+tempNewEntityAddress["entity_city"]+" "+tempNewEntityAddress["entity_state"]+" "+tempNewEntityAddress["entity_zip"]+" "+tempNewEntityAddress["entity_country"];
        tempNewEntityAddress["primary_address_id"]=this.props?.project_id;
        tempNewEntityAddress["value"]="External Contact-"+talentName+this.props?.project_id;
        tempNewEntity["address"]=[tempNewEntityAddress];
        let matchingOption = null;
        matchingOption = this.state?.talentOptionsBackup?.findIndex(item => (item.project_crew_id === this.props?.deal_id && item.entity_type == "E"));
        if(matchingOption === -1 || matchingOption === null){
            talentOptions.splice(this.state.backUpTalentOptions?.length,0,tempNewEntity);
        }else{
            talentOptions.splice(matchingOption,1);
            talentOptions.splice(matchingOption,0,tempNewEntity);
        }
        let selectedEntity = this.state.talentOptions?.find(item => item?.value === "External Contact-"+talentName);
        let selectedAddress = selectedEntity?.address?.[0]?.value;

        this.setState({selectedExternalPayeeAddress : address, newExternalTalent:talentName, talentOptions, selectedEntity, selectedAddress, addressOptions: selectedEntity?.address},()=>{
            this.onClosePopup(this.state.selectedEntity?.address && this.state?.editExternalUserSection ? "edit" : "new");
        })

    }
    deleteExternalContactPayment = () => {
        let postObj = {}
        if (this.state.selectedEntity) {
            this.setState({is_deleting:true})
            let objToUse = this.state.selectedEntity?.address?.length>0 ? this.state.selectedEntity?.address?.[0]:{};
            postObj.selected_alias_name = this.state.newExternalTalent;
            postObj.project_id = this.props?.project_id || null
            postObj.performer_deal_id = this.props?.deal_id || null
            postObj.is_send_payment_to = 1,
            postObj.entity_id = this.props?.deal_id || null
            postObj.entity_type = "E"
            postObj.address_type = objToUse?.address_type || null,
            //postObj.entity_full_address = addressInfo?.entity_full_address || null
            postObj.entity_notes = this.state.notes || null
            postObj.entity_address = objToUse?.entity_address|| null,
            postObj.entity_state =  objToUse?.entity_state || null,
            postObj.entity_city =  objToUse?.entity_city|| null,
            postObj.entity_country =  objToUse?.entity_country || null,
            postObj.entity_zip =  objToUse?.entity_zip|| null,
            postObj.talent_id =  this.props?.talentId || null,
            postObj.is_delete =  "1"
            this.postRepresentativeDetails(postObj,"fromDelete")
        }
        
    }
    editExternalContactPayment = () => {
        let tempAddress = this.state.selectedEntity?.address||[];
        if(tempAddress?.length>0){
            tempAddress[0]["city"]=this.state.selectedEntity?.address?.[0]?.entity_city;
            tempAddress[0]["zip"]=this.state.selectedEntity?.address?.[0]?.entity_zip;
            tempAddress[0]["address"]=this.state.selectedEntity?.address?.[0]?.entity_address;
            tempAddress[0]["state"]=this.state.selectedEntity?.address?.[0]?.entity_state;
            tempAddress[0]["country"]=this.state.selectedEntity?.address?.[0]?.entity_country;
        }
        
        this.setState((prevState) => ({
            selectedEntity: {
                ...prevState?.selectedEntity,
                ["address"]: tempAddress
            },
            newExternalTalent: this.state?.selectedExternalPayeeAddress ? this.state.newExternalTalent :this.state?.selectedEntity?.selected_alias_name , 
            editExternalUserSection: !this.state.editExternalUserSection,
            openNewExternalUserSection: false,
        }))
    }
    onClosePopup = () => {
        let mode = this.state?.editExternalUserSection ? "edit" : "new"
        if(mode === "edit"){
            this.editExternalContactPayment();
        }else if(mode === "new"){
            this.addNewExternalContactPayment();
        }
    }
    openDeleteModal = () =>{
        this.setState({is_delete_flag:true})
    }
    onAddressChange = (value) => {
        this.props.fieldChanged(true, "change");
        this.setState({ selectedAddress: value })
    }

    render() {
        return (
            <div className="loaderEditSendPaymentsTo">
                {this.state.isFetchingData ? <CircularProgress className="loadEditSendPaymentsTo" /> :
                    <MDBContainer className="mt-5 editSendPaymentsTo">
                        <MDBRow>
                            <MDBCol md={7} className="editAddBtnWrapper">
                            </MDBCol>
                            <MDBCol md={5} className="editAddBtnWrapper">
                            <BasicButton
                                text={"External Contact Payment"}
                                type="inline"
                                onClick={() => this.addNewExternalContactPayment()}
                                className='FR MR'
                                icon={'plus'}
                                disabled ={this.state?.talentOptions?.find(item => item?.entity_type==="E" && (item?.address?.length>0 && item?.address?.[0]?.primary_address_id == this.props?.project_id) ? true : false)}
                            />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={4} className="talentDrop">
                                    <SearchSelectField
                                        id={"talentSendPaymentsTo"}
                                        label={"Talent"}
                                        value={this.state.selectedEntity || []}
                                        options={this.state?.talentOptions || []}
                                        // limitTags={4}
                                        onChange={(e, value) => {
                                            this.props.fieldChanged(true, "change");
                                            this.onChange(value)
                                        }}
                                        // multiple={true}
                                        width={'100%'}
                                        isMandatory={true}
                                        placeholder={"-Select-"}
                                    />
                            </MDBCol>
                            <MDBCol md={6} className="addressDrop">
                                {(this.state?.openNewExternalUserSection || this.state?.editExternalUserSection) &&
                                    <AddressComponent
                                        open={this.state?.openNewExternalUserSection || this.state?.editExternalUserSection}
                                        // setPopOver={this.state?.setPopOver}
                                        displayTalentField = {true}
                                        displayIsPrimaryCheckbox = {false}
                                        talentName = {this.state?.editExternalUserSection && this.state.selectedEntity?.project_crew_id ? this.state.selectedEntity?.selected_alias_name : this.state?.newExternalTalent}
                                        handleClose={this.onClosePopup.bind(this)}
                                        onSave={this.updateAddress.bind(this)}
                                        mode={
                                        this.state.selectedEntity?.address && this.state?.editExternalUserSection
                                            ? "edit"
                                            : "new"
                                        }
                                        id={this.state.selectedEntity?.entity_id && this.state?.editExternalUserSection ? this.state.selectedEntity?.entity_id : null}
                                        selectedAddress={this.state?.editExternalUserSection ? (this.state.selectedEntity?.address?.[0] && this.state.selectedEntity?.project_crew_id) ? this.state.selectedEntity?.address?.[0] : this.state?.selectedExternalPayeeAddress ? this.state?.selectedExternalPayeeAddress : null : null}
                                        origin = "fromContactPayment"
                                    />
                                }
                                <SelectField
                                    label={"Address"}
                                    className={!this.state.selectedAddress?"disabledAddressDrop":""}
                                    value={this.state.selectedAddress || null}
                                    options={this.state.addressOptions}
                                    onChange={(e) => {
                                        this.onAddressChange(e.target.value)
                                    }}
                                    isMandatory={true}
                                    showMandatory={this.state.postInitiated || false}
                                    placeHolderText={'-Select Address-'}
                                />
                            </MDBCol>
                            <MDBCol md={1} className="talentDrop">
                                <p> </p>
                                {this.state.selectedEntity?.entity_type === "E" && ((this.state.selectedEntity?.address?.length>0 && this.state.selectedEntity?.address?.[0]?.primary_address_id === Number(this.props?.project_id)) || this.state.selectedEntity?.project_crew_id===null) &&
                                    <BasicButton
                                        text={""}
                                        type="inline"
                                        onClick={() => this.editExternalContactPayment()}
                                        className='FR MR'
                                        icon={'pen'}
                                    />
                                }
                            </MDBCol>
                            <MDBCol md={1} className="talentDrop">
                                <p> </p>
                                {this.state.selectedEntity?.entity_type === "E" && (this.state.selectedEntity?.address?.length>0 && this.state.selectedEntity?.address?.[0]?.primary_address_id === Number(this.props?.project_id)) &&
                                    <BasicButton
                                        text={""}
                                        type="inline"
                                        //onClick={() => this.deleteExternalContactPayment()}
                                        onClick = {()=> this.openDeleteModal()}
                                        className='FR MR'
                                        icon={'trash'}
                                    />
                                }
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={12} className="addressDrop">
                                <BasicTextArea
                                    label={"Notes"}
                                    value={this.state.notes || null}
                                    onChange={(e) => {
                                        this.props.fieldChanged(true, "change");
                                        this.setState({ notes: e.target.value })
                                    }}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className='mt-5'>
                            <MDBCol md={8}></MDBCol>
                            <MDBCol md={2}>
                                <BasicButton
                                    text={this.state.isPosting ? <CircularProgress color="inherit" size={20} /> : "Save"}
                                    type="inline"
                                    onClick={() => this.handleSubmit()}
                                    className='FR MR'
                                    icon='save'
                                />
                            </MDBCol>
                            <MDBCol md={2}>
                                <BasicButton
                                    variant="outlined"
                                    text="Cancel"
                                    className='FR MR'
                                    icon='times'
                                    onClick={this.props.onClose}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MessageModal
                            open={this.state.is_delete_flag}
                            title={"Delete External Contact"}
                            message={this.state.is_delete_flag && `Are you sure you want to delete External Contact "${this.state?.selectedEntity?.selected_alias_name}"? Please click Yes to confirm`}
                            hideCancel={false}
                            primaryButtonText={this.state.is_deleting ? (<CircularProgress color="inherit" size={18} />) : ("Yes")}
                            secondaryButtonText={"NO"}
                            handleClose={() => this.setState({ is_delete_flag: false })}
                            onConfirm={(e) => {
                                this.deleteExternalContactPayment()
                            }} />
                    </MDBContainer>}
            </div>
        );
    }
}

export default EditSendPaymentsTo;
